import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Model, QueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const CUSTOM_EXAMS_URL = `${API_URL}/Custom/GetSemesterCourseExams`
const CUSTOM_EXAM_DETAIL_URL = `${API_URL}/Custom/GetExamForInstructor`
const CUSTOM_UPDATE_EXAM_URL = `${API_URL}/Custom/UpdateExamForInstructor`
const CUSTOM_DELETE_EXAM_URL = `${API_URL}/Custom/DeleteExamForInstructor`
const CUSTOM_EXAM_TYPES_URL = `${API_URL}/Custom/GetExamTypes`
const CUSTOM_COURSE_OUTCOMES_URL = `${API_URL}/Custom/GetCourseOutcomes`
const CREATE_EXAM = `${API_URL}/Custom/CreateExam`

const getExam = (semesterCourseId: ID, query: string): Promise<QueryResponse> => {
  return axios
    .get(`${CUSTOM_EXAMS_URL}?semesterCourseId=${semesterCourseId}&${query}`)
    .then((d: AxiosResponse<QueryResponse>) => d.data)
}

const listExam = async (semesterCourseId: ID, query?: string): Promise<Model[]> => {
  const effectiveQuery = query ?? 'page=1&items_per_page=9999'
  const response = await getExam(semesterCourseId, effectiveQuery)
  return response.data ?? []
}

const getExamById = (id: ID): Promise<Model | undefined> => {
  return axios
    .get(`${CUSTOM_EXAM_DETAIL_URL}?examId=${id}`)
    .then((response: AxiosResponse<Model>) => response.data)
}

const CustomCreateExam = (payload: any): Promise<any | undefined> => {
  return axios.post(CREATE_EXAM, payload)
}

const updateExam = (prop: Model): Promise<any> => {
  return axios.post(CUSTOM_UPDATE_EXAM_URL, prop).then((response: AxiosResponse<Response<any>>) => response.data)
}

const deleteExam = (propId: ID): Promise<void> => {
  return axios.delete(`${CUSTOM_DELETE_EXAM_URL}/${propId}`).then(() => {})
}

const deleteSelectedExam = (propIds: Array<ID>): Promise<void> => {
  const requests = propIds.map((id) => deleteExam(id))
  return axios.all(requests).then(() => {})
}

const getExamTypes = (): Promise<Array<{id: number; name: string}>> => {
  return axios.get(CUSTOM_EXAM_TYPES_URL).then((response: AxiosResponse<Array<{id: number; name: string}>>) => response.data)
}

const getCourseOutcomesForSemesterCourse = (
  semesterCourseId: ID
): Promise<Array<{id: number; name?: string; questionCount?: number | null}>> => {
  return axios
    .get(`${CUSTOM_COURSE_OUTCOMES_URL}?semesterCourseId=${semesterCourseId}`)
    .then((response: AxiosResponse<any>) => {
      const data = response?.data
      if (Array.isArray(data)) {
        return data as Array<{id: number; name?: string; questionCount?: number | null}>
      }

      if (data && typeof data === 'object' && Array.isArray((data as any).items)) {
        return (data as any).items as Array<{id: number; name?: string; questionCount?: number | null}>
      }

      return []
    })
}

export {
  getExam,
  deleteExam,
  deleteSelectedExam,
  getExamById,
  updateExam,
  listExam,
  CustomCreateExam,
  getExamTypes,
  getCourseOutcomesForSemesterCourse,
}
